import React, { useState, useEffect } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { useScroll } from 'react-use';
import ImageGridList from 'components/ImageGridList';
import styles from './styles.module.scss';
import { CircularProgress, Paper, Typography } from '@material-ui/core';
import BottomNav from 'components/BottomNav';
import TopNav from 'components/TopNav';
import { useQuery } from 'react-query';
import * as agentApi from 'api/agent';

const pageSize = 10;

function AgentCharaList(props) {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  const scrollRef = React.useRef(null);
  const { y } = useScroll(scrollRef);
  const [filter, setFilter] = useState({ pageIndex: 1, pageSize });
  const { data: agentList, isLoading } = useQuery(['agentList', id, filter], () =>
    agentApi.getCardList({ id, filter })
  );

  useEffect(() => {
    const homePageOffetHeigt = document.querySelector('#pageContainer').offsetHeight - window.innerHeight;
    if (y && y >= homePageOffetHeigt + 50 && agentList?.data?.length < agentList?.totalRow) {
      setFilter((filter) => ({ ...filter, pageIndex: filter.pageIndex + 1 }));
    }
  }, [y, agentList]);

  const cardList = () => {
    return (
      <ImageGridList
        checked={true}
        cards={agentList?.data}
        selectCardFunc={(card) => {
          selectCard(card);
        }}
      />
    );
  };

  const selectCard = (card) => {
    let url = '/user/' + card.id;
    history.push({ pathname: url, state: { prevPath: location.pathname } });
  };

  return (
    <div style={{ overflow: 'auto', height: '100vh', maxWidth: 560, margin: 'auto' }} ref={scrollRef}>
      <div id="pageContainer" className={styles.homePage}>
        <div className={styles.topNavContainer}>
          <TopNav name={props.location.state.name + '会社/店舗キャラ一覧'} hasBackIcon={true} dir={`/agent-profile/${id}`}/>
        </div>
        {isLoading && filter.pageIndex === 1 ? (
          <div className={styles.loading}>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <div className={styles.cardImage}>
            {!agentList?.data?.length ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                <center>
                  <Typography variant="h6" className='font-2'>{agentList?.message}</Typography>
                </center>
              </div>
            ) : (
              <React.Fragment>{cardList()}</React.Fragment>
            )}
          </div>
        )}
        {isLoading ? null : <Paper className={styles.paper} elevation={0} />}
        <BottomNav />
      </div>
    </div>
  );
}

export default AgentCharaList;
